module.exports = __webpack_public_path__ + "static/media/logo-iona.fa74bdc8.png";